import {
  createContext,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react';

type DraggingState = {
  alias: string;
  isTaxonomy: boolean;
  forceRemove: boolean;
};

export type TaxonomyDragContextT = {
  isDragging: DraggingState | null;
  setIsDragging: (startTopicAlias: DraggingState | null) => void;
  selectedList: ClassifiedFeedbackUnit[];
  setSelectedList: Dispatch<SetStateAction<ClassifiedFeedbackUnit[]>>;
};

const TaxonomyDragContext = createContext<TaxonomyDragContextT>({
  isDragging: null,
  setIsDragging: () => {},
  selectedList: [],
  setSelectedList: () => {},
});

type ProviderProps = {
  children: ReactNode;
  taxonomyAlias: string;
  topicAlias?: string;
};

const TaxonomyDragProvider = (props: ProviderProps) => {
  const [isDragging, setIsDragging] = useState<DraggingState | null>(null);
  const [selectedList, setSelectedList] = useState<ClassifiedFeedbackUnit[]>(
    [],
  );

  useEffect(() => {
    setSelectedList([]);
    setIsDragging(null);
  }, [props.taxonomyAlias, props.topicAlias]);

  return (
    <TaxonomyDragContext.Provider
      value={{ isDragging, setIsDragging, selectedList, setSelectedList }}
    >
      {props.children}
    </TaxonomyDragContext.Provider>
  );
};

const useTaxonomyDrag = () => useContext(TaxonomyDragContext);

export { TaxonomyDragContext, TaxonomyDragProvider, useTaxonomyDrag };
